import React, { FC } from 'react'
import './share-card.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


type SharePlatform = 'twitter' | 'facebook' | 'instagram' | 'email' | 'phone' | 'share-sheet' | 'clipboard'
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    url: URL | string
    onShared?: (platform: SharePlatform, meta?: { [key: string]: any }) => void
    inline?: boolean
}


const ShareCard: FC<Props> = (props) => {
    const { className: classProps, url = '', inline, onShared, ...divProps } = props
    const className = flatten(inline ? "inline" : undefined, "share-card flex flex-row items-center select-none", classProps)
    const { share, canShare } = useShareSheet({ url: url.toString() })

    async function shareTo(platform: SharePlatform) {
        const encodedSharelink = encodeURI(url.toString())
        let meta: { [key: string]: any } | undefined = undefined

        switch (platform) {
            case 'twitter':
                window.open(`https://twitter.com/intent/tweet?url=${encodedSharelink}`, '_blank')
                break
            case 'facebook':
                window.open(`https://facebook.com/sharer/sharer.php?u=${encodedSharelink}`, '_blank')
                break
            case 'instagram':
                window.open(`https://www.instagram.com/accounts/login?u=${encodedSharelink}`, '_blank')
                break
            case 'email':
                window.open(`mailto:?body=${url.toString()}`)
                break
            case 'phone':
                const userAgent = window.navigator.userAgent
                if (userAgent.match(/iPhone/i) || userAgent.match(/Android/i)) window.open(`sms:?&body=${url.toString()}`)
                break
            case 'share-sheet':
                if (canShare) await share()
                break
            case 'clipboard':
                try {
                    await window.navigator.clipboard.writeText(url.toString())
                    meta = { copied: true }
                } catch (error) {
                    console.log(error)
                    meta = { copied: false }
                }
                break
        }
        if (onShared) onShared(platform, meta)
    }

    return (
        <div className={className} {...divProps} onClick={() => { shareTo(canShare ? 'share-sheet' : 'clipboard') }}>
            <div className="share-icon" />
            <div style={{ display: 'flex', flexFlow: 'column nowrap', alignItems: 'stretch', textAlign: 'left', flex: 1 }}>
                <p><strong style={{ fontWeight: 'bold' }}>Tap to share</strong></p>
                <small>Send this invite link to the others in your group. They can then join, and pay their share.</small>
            </div>
        </div>
    )
}

export const useShareSheet = (shareData: ShareData, onShared?: () => void) => {
    const canShare = (window.navigator.canShare && window.navigator.canShare(shareData))
    async function share() {
        if (canShare) {
            await window.navigator.share(shareData)
            if (onShared) onShared()
        }
    }

    return { share, canShare }

}

export default ShareCard
